export default __webpack_public_path__ + "assets/css/fotorama@2x.png";